"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createUrqlClient = void 0;

var dashboard_constants_1 = require("@hopin-team/dashboard-constants");

var package_details_1 = require("@hopin-team/package-details");

var exchange_graphcache_1 = require("@urql/exchange-graphcache");

var urql_1 = require("urql");

var graphql_1 = require("./graphql");

var createUrqlClient = function createUrqlClient(authToken, clientPackageDetails) {
  var _a = (0, package_details_1.packageDetails)(clientPackageDetails || '@hopin-team/unknown/*'),
      name = _a.name,
      clientVersion = _a.version;

  return (0, urql_1.createClient)({
    url: (0, dashboard_constants_1.getGraphQLUrl)(),
    exchanges: [urql_1.dedupExchange, (0, exchange_graphcache_1.cacheExchange)((0, graphql_1.cachingConfig)()), urql_1.fetchExchange],
    fetchOptions: function fetchOptions() {
      return {
        headers: {
          authorization: "Bearer ".concat(authToken),
          'X-HOPIN-CLIENT-NAME': name,
          'X-HOPIN-CLIENT-VERSION': clientVersion,
          'x-hopin': '1'
        }
      };
    }
  });
};

exports.createUrqlClient = createUrqlClient;